var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiplom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5412 0L13.5931 1.57988L16.9906 2.09554L18.5303 5.16753L20.975 7.58124L20.4155 10.9714L20.975 14.3616L18.5303 16.7753L16.9906 19.8473L13.5931 20.3629L10.5412 21.9428L7.48935 20.3629L4.09187 19.8473L2.55222 16.7753L0.107422 14.3616L0.666964 10.9714L0.107422 7.58124L2.55222 5.16753L4.09187 2.09554L7.48935 1.57988L10.5412 0Z",
    fill: "#214ba5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06763 11.4443L6.19888e-06 23.6858L3.28967 23.4737L4.75077 26.4287L11.8184 14.1872L10.3402 13.9799L8.22518 14.9251L7.98623 12.6208L7.06763 11.4443Z",
    fill: "#214ba5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0569 13.7139L17.1245 25.9553L18.5856 23.0003L21.8753 23.2125L14.8076 10.971L13.889 12.1475L13.6501 14.4518L11.535 13.5066L10.0569 13.7139Z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiplom);
export default __webpack_public_path__ + "static/media/diplom.850c30856730e8f5744cc6d423a913e7.svg";
export { ForwardRef as ReactComponent };